exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.heghtHeader[data-v-758131d8]{\n  height: 110px;\n}\n.titleHeader[data-v-758131d8] {\n  font-size: 23px;\n  font-weight: 300;\n  text-align: center;\n  border-bottom: 4px solid #f98ea1;\n  padding: 18px 0px;\n  position: relative;\n}\n", ""]);

// exports
